export default "__VITE_PUBLIC_ASSET__73b5ffbc__"